import { ISessionInfo } from '../types/ISessionInfo';
import { Request } from './Request';

export interface IGetSessionInfoParams {
}

export interface IGetSessionInfoResult extends ISessionInfo {
}

export class GetSessionInfoRequest extends Request<IGetSessionInfoParams, IGetSessionInfoResult> {
  constructor() {
    super('getSessionInfo', {});
  }
}
